/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useReducer, useState } from "react";
import cx from "classnames";
// import { CSSTransition } from "react-transition-group";
// import "../../../Transition/fade.css";
import Spinner from "../../../../../../../components/Loader/Spinner";
import ReactSVG from "react-svg";
import { useToggle } from "resap";
import { useSelector } from "react-redux";
import { format } from "date-fns-tz";
import { CMS_ASSET_URL_BASE } from "../../../../../../../config";
import {
  setMaxSeatsReached,
  getMaxSeatsReached,
  setResetSeats,
  setIsIsolated,
  getIsIsolated,
  setSelectedSeatsNodes,
  removeSelectedSeatsNodes,
  getSelectedSeatsNodes,
  getMainSections,
  setSelectedMainSection,
  getSelectedMainSection,
  setSectionsAvailableSeats,
} from "../../../../../../../features/singleGroup/singleGroupSlice";
import store from "../../../../../../../store";

import {
  getSectionNameById,
  getSectionIdByName,
  mapAvailableSections,
  mapSectoionStyles,
  mapAllTdcTo3dd,
  mapTdcTo3dd,
  findTdcBy3dd,
  getSectionObjById,
} from "./map3DHelper";

import classes from "./Map3D.module.scss";

import StartOver from "../../../../../../../assets/images/startOver.svg";
import ArrowLeft from "../../../../../../../assets/images/arrowLeft.svg";
import Axios from "axios";
import { API_URL } from "../../../../../../../config";

const VENUE_ID = "nam-us-10185-nationals";
const HOME_PATH = ["areamap_full_v2"];

const mapInitState = {
  viewerInstance: null,
  viewer3dInstance: null,
  routePath: HOME_PATH,
  mainSections: null,
  hoveredSeat: { row: "--", seat: "--" },
  hoveredSection: null,
  seatDropdown: false,
  loading: false,
  noSeatsAvailable: false,
  seatsAvailableError: false,
  maxSeatsSelected: false,
};

const mapReducer = (state, action) => {
  switch (action.type) {
    case "SET_VIEWER_INSTANCES":
      return {
        ...state,
        viewerInstance: action.viewerInstance,
        viewer3dInstance: action.viewer3dInstance,
      };

    case "ADD_ROUTE_PATH":
      return { ...state, routePath: [...state.routePath, action.section] };

    case "RESET_ROUTE_PATH":
      return { ...state, routePath: HOME_PATH };

    case "LOADING":
      return { ...state, loading: action.loading };

    case "NO_SEATS_AVAILABLE":
      return { ...state, noSeatsAvailable: action.notAvailable };

    case "SEATS_AVAILABLE_ERROR":
      return { ...state, seatsAvailableError: action.error };

    case "REMOVE_ROUTE_PATH":
      const _routePath = state.routePath;
      _routePath.pop();
      return {
        ...state,
        routePath: _routePath,
      };
    case "SET_MAIN_SECTIONS":
      return { ...state, mainSections: action.mainSections };

    case "SET_HOVERED_SEAT":
      return { ...state, hoveredSeat: action.seatInfo };

    case "RESET_HOVERED_SEAT":
      return { ...state, hoveredSeat: { row: "--", seat: "--" } };

    case "SET_HOVERED_SECTION":
      return { ...state, hoveredSection: action.sectionName };

    case "RESET_HOVERED_SECTION":
      return { ...state, hoveredSection: null };

    default:
      return state;
  }
};

function Map3D(props) {
  const {
    seatsInfo,
    formStyle,
    loaderShow,
    parentClasses,
    seatInfoSelectedKey,
    flexMultiply,
    planTitle,
    planName,
    uuid,
    toggleSubmit,
    adaLink,
    switchPlanMsg,
    history,
    NumberOfTicketClickHandler,
  } = props;
  const { groupNumOfTickets, groupGameSelected } = useSelector(
    (state) => state?.singleGroup
  );
  const selectedSeatsNodes = useSelector(getSelectedSeatsNodes);
  const mainSections = useSelector(getMainSections);
  const selectedMainSection = useSelector(getSelectedMainSection);
  const maxSeatsReached = useSelector(getMaxSeatsReached);
  const isIsolated = useSelector(getIsIsolated);

  const groupNumOfTicketsRef = useRef(null);
  const mapContainerRef = useRef(null);
  const zoomInRef = useRef(null);
  const zoomOutRef = useRef(null);
  const viewer3dContainerRef = useRef(null);
  const selectedSeatsNodesRef = useRef(null);
  const mainSectionsRef = useRef(null);
  const currentSectionName = useRef();
  const cachedMapState = useRef(0);
  const leftToSelect = useRef(groupNumOfTickets);
  const [mapState, dispatch] = useReducer(mapReducer, mapInitState);
  const [openSection, setOpenSection] = useState(false);
  const [dragIsAnimating, setDragIsAnimating] = useState(false);

  const { current: openSectionProps } = useRef({
    left: 0,
    duration: 0.5,
    ease: "power4.inOut",
  });
  const refOpenSection = useToggle(!openSection, openSectionProps);
  const routePath = mapState.routePath;
  const lastPage = routePath[routePath.length - 1];

  const mapClickHandler = async (obj) => {
    var viewer = obj.instance;
    var node = obj.nodes[0];
    if (node?.type === "section") {
      const routePath = cachedMapState.current.routePath;
      const lastPage = routePath[routePath.length - 1];
      if (node?.id === lastPage || node?.state === "unavailable") return;
      dispatch({
        type: "ADD_ROUTE_PATH",
        section: node?.id,
      });
      // console.log("mainSectionsRef.current", mainSectionsRef.current);
      const _mainSectionSelected = mainSectionsRef.current.find((obj) => {
        // console.log({
        //   one: obj.section,
        //   nodeId: node.id,
        //   two: getSectionObjById(node.id).sectionId,
        // });
        return obj.section === getSectionObjById(node.id).sectionId;
      });

      // console.log("_mainSectionSelected", _mainSectionSelected);
      setTimeout(() => {
        // console.log("a", mainSectionsRef.current);
        if (_mainSectionSelected) {
          store.dispatch(
            setSelectedMainSection({
              ..._mainSectionSelected,
              price: _mainSectionSelected?.pricesFrom["41319"],
            })
          );
        }
      }, 1500);
    }
    if (node?.type === "seat") {
      if (mapState.loading || node?.state === "unavailable") return;

      cachedMapState.current.viewerInstance.max_selection =
        leftToSelect.current;

      if (node.state === "selected") {
        const success = await viewer.unselect(node);
        if (success) {
          store.dispatch(removeSelectedSeatsNodes(node.id));
        }
      } else if (node.state === "available") {
        const success = await viewer.select(node);
        if (
          success &&
          selectedSeatsNodesRef.current?.length < groupNumOfTicketsRef.current
        ) {
          store.dispatch(setSelectedSeatsNodes([node.id]));
        }
      }
    }
  };
  const deleteSelectedSeat = (seat) => {
    store.dispatch(removeSelectedSeatsNodes(seat));
    mapState.viewerInstance.unselect(seat);
  };

  const startSelectionAreaHandler = (obj) => {
    console.log("start");
  };
  const updateSelectionAreaHandler = (obj) => {
    var viewer = obj.instance;
    if (obj.selection_area) {
      obj.instance.max_selection = leftToSelect.current;
      viewer.select(obj.selection_area.added);
    }
  };
  const endSelectionAreaHandler = (obj) => {
    console.log("end");
    var viewer = obj.instance;
    if (obj.selection_area) {
      const selectedSSeats = obj.selection_area.current
        .filter((seat) => seat?.type === "seat" && seat?.state === "selected")
        .map((s) => {
          const _node = viewer.getNodeById(s.id);
          return _node.id;
        });
      store.dispatch(
        setSelectedSeatsNodes(selectedSSeats?.slice(0, leftToSelect.current))
      );
    }
  };
  const checkIsolated = (obj) => {
    // console.log(
    //   "cachedMapState.current.loading",
    //   cachedMapState.current.loading
    // );
    if (!cachedMapState.current.loading) {
      const viewer = obj.instance;
      var isolated = viewer.checkIsolatedNodes();
      store.dispatch(setIsIsolated(isolated?.length > 0));
    }
  };
  const mapHoverHandler = (obj) => {
    var node = obj.nodes[0];
    if ((node.type = "seat")) console.log("node hover", node);
  };
  const goBackHandler = () => {
    if (routePath.length <= 1 || isIsolated) {
      return;
    }
    dispatch({ type: "REMOVE_ROUTE_PATH" });
  };
  const goHomeHandler = () => {
    if (routePath.length <= 1 || isIsolated) {
      return;
    }
    // dispatch({ type: "RESET_SELECTED_SEATS" });
    dispatch({ type: "RESET_ROUTE_PATH" });
  };
  const removeAllSelectedSeats = () => {
    store.dispatch(setResetSeats());
    dispatch({ type: "RESET_ROUTE_PATH" });
    mapState.viewerInstance.unselectAll();
  };
  const mapLeaveHandler = () => {
    dispatch({
      type: "RESET_HOVERED_SECTION",
    });
  };
  const listSectionClickHandler = (seat) => {
    // console.log("seatsInfo", seatsInfo);
    // console.log("seat", seat);

    store.dispatch(
      setSelectedMainSection({ ...seat, price: seat.pricesFrom["41319"] })
    );

    const id = getSectionIdByName(seat.name);
    if (id === lastPage) return;
    if (routePath.length === 3) {
      dispatch({ type: "RESET_ROUTE_PATH" });
    }
    dispatch({
      type: "ADD_ROUTE_PATH",
      section: id,
    });
  };
  const listSectionHoverHandler = (name) => {
    cachedMapState.current.viewerInstance.hover(getSectionIdByName(name));
  };
  const loadMapHandler = () => {
    const mapId = mapState.routePath[mapState.routePath.length - 1];
    var load_options = {
      venue_id: VENUE_ID,
      map_id: mapId,
    };

    mapState.viewerInstance
      .loadMap(load_options)
      .then(function (obj) {
        const viewer = obj.instance;
        viewer.setStyles(mapSectoionStyles);
        switch (mapState.routePath.length) {
          case 1:
            // reset no seat available
            store.dispatch(setResetSeats());
            dispatch({
              type: "NO_SEATS_AVAILABLE",
              notAvailable: false,
            });
            dispatch({
              type: "SEATS_AVAILABLE_ERROR",
              error: false,
            });
            // reset isolated seat
            store.dispatch(setIsIsolated(false));
            viewer.setAvailability(
              "section",
              mapState.mainSections.filter((x) => x?.id)
            );

            setOpenSection(false);
            // reset selected main section
            store.dispatch(setSelectedMainSection(""));
            break;
          case 2:
            // reset no seat available
            dispatch({
              type: "NO_SEATS_AVAILABLE",
              notAvailable: false,
            });
            dispatch({
              type: "SEATS_AVAILABLE_ERROR",
              error: false,
            });
            // reset isolated seat
            store.dispatch(setIsIsolated(false));
            setOpenSection(true);
            const TdcSection = getSectionObjById(mapId).sectionId;
            mapState.viewer3dInstance.loadView3d({
              venue_id: VENUE_ID,
              view_id: mapTdcTo3dd(TdcSection),
            });
            viewer.setAvailability(
              "section",
              mapAllTdcTo3dd(seatsInfo, mapState.routePath[1])
            );

            break;
          case 3:
            setTimeout(() => {
              setDragIsAnimating(true);
              setTimeout(() => {
                setDragIsAnimating(false);
              }, 4000);
            }, 1000);
            mapState.viewer3dInstance.loadView3d({
              venue_id: VENUE_ID,
              view_id: mapId,
            });
            dispatch({
              type: "LOADING",
              loading: true,
            });

            const allSelectedSeatCount = selectedSeatsNodes?.length;
            leftToSelect.current =
              groupNumOfTicketsRef.current - allSelectedSeatCount;

            const _tdcSection = getSectionObjById(
              mapState.routePath[1]
            ).sectionId;

            Axios.post(`${API_URL}/getEventSeatAvailability`, {
              // sectionId: _tdcSection,
              sectionId: findTdcBy3dd(mapId),
              sectionName: getSectionNameById(
                mapState.routePath[mapState.routePath.length - 2]
              ),
              eventId: groupGameSelected?.eventId,
            })
              .then((response) => {
                if (response?.data?.status === "error") {
                  dispatch({
                    type: "SEATS_AVAILABLE_ERROR",
                    error: true,
                  });
                  setTimeout(() => {
                    dispatch({
                      type: "LOADING",
                      loading: false,
                    });
                  }, 300);
                } else {
                  const availableSeats =
                    response?.data?.info?.availableSeats.map((seat) => {
                      return `${mapId}-${seat?.row}-${seat?.seatNumber}`;
                    });

                  if (
                    !response?.data?.info?.availableSeats ||
                    response?.data?.info?.availableSeats.length <= 0 ||
                    !availableSeats
                  ) {
                    setTimeout(() => {
                      dispatch({
                        type: "NO_SEATS_AVAILABLE",
                        notAvailable: true,
                      });
                    }, 200);
                    setTimeout(() => {
                      dispatch({
                        type: "LOADING",
                        loading: false,
                      });
                    }, 300);
                  } else {
                    viewer.setAvailability("seat", availableSeats);

                    store.dispatch(
                      setSectionsAvailableSeats({
                        section: mapId,
                        seats: response?.data?.info?.availableSeats,
                      })
                    );

                    setTimeout(() => {
                      selectedSeatsNodes.forEach((node) => {
                        var nodeToSelect = viewer.getNodeById(node);
                        if (nodeToSelect?.state === "available") {
                          nodeToSelect.instance.select(nodeToSelect);
                        }
                      });

                      // viewer.select(selectedSeatsNodes);
                      // setTimeout(() => {
                      dispatch({
                        type: "LOADING",
                        loading: false,
                      });
                      // }, 1000);
                    }, 2000);
                  }
                }
              })
              .catch((error) => {
                dispatch({
                  type: "LOADING",
                  loading: false,
                });
                dispatch({
                  type: "SEATS_AVAILABLE_ERROR",
                  error: true,
                });
                console.log("error", error);
              });

            break;
          default:
            break;
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  };
  useEffect(() => {
    const mapInputOptions = {
      container: mapContainerRef.current,
      plugins: ["selection_area"],
      callbacks: {
        click: mapClickHandler,
        // enter: mapHoverHandler,
        // leave: mapLeaveHandler,
      },
    };

    const viewer3dInputOptions = {
      venue_id: VENUE_ID,
      container: viewer3dContainerRef.current,
    };

    const viewerPromise = window.DVM.loadModule("map_viewer", mapInputOptions);
    const viewer3dPromise = window.DVM.loadModule(
      "3d_viewer",
      viewer3dInputOptions
    );

    Promise.all([viewerPromise, viewer3dPromise])
      .then(function (result) {
        const _viewer = result[0];
        const _viewer3d = result[1];

        _viewer.flags.automatic_selection = false;
        // _viewer.max_selection = 99;
        // _viewer.max_selection = groupNumOfTicketsRef.current;
        _viewer.flags.fixed_aspect_ratio = true;
        _viewer3d.flags.fixed_aspect_ratio = false;
        _viewer.selection_area.style_options.border_color1 = "#FF0000";
        // _viewer.selection_area.mouse_options.ctrlKey = false;
        // _viewer.selection_area.enabled = false;

        _viewer.bindInterfaceAction(zoomInRef.current, "zoom-in");
        _viewer.bindInterfaceAction(zoomOutRef.current, "zoom-out");
        // _viewer.max_selection = 6;
        _viewer.subscribe("select", checkIsolated);
        _viewer.subscribe("unselect", checkIsolated);
        _viewer.subscribe("start_selection_area", startSelectionAreaHandler);
        _viewer.subscribe("update_selection_area", updateSelectionAreaHandler);
        _viewer.subscribe("end_selection_area", endSelectionAreaHandler);

        dispatch({
          type: "SET_VIEWER_INSTANCES",
          viewerInstance: _viewer,
          viewer3dInstance: _viewer3d,
        });

        store.dispatch(setResetSeats());
        dispatch({ type: "RESET_ROUTE_PATH" });
        _viewer.unselectAll();
      })
      .catch(function (err) {
        console.error(err);
      });
  }, []);
  useEffect(() => {
    // console.log("loaderShow");
    dispatch({ type: "RESET_ROUTE_PATH" });
    if (props.loaderShow) {
    }
  }, [props.loaderShow]);
  useEffect(() => {
    cachedMapState.current = mapState;
    groupNumOfTicketsRef.current = groupNumOfTickets;
    selectedSeatsNodesRef.current = selectedSeatsNodes;
    mainSectionsRef.current = mainSections;

    currentSectionName.current = getSectionNameById(
      mapState.routePath[mapState.routePath.length - 1]
    );

    if (seatsInfo) {
      mapAvailableSections(seatsInfo).then((availability) => {
        const isSameSeats =
          JSON.stringify(mapState.mainSections) ===
          JSON.stringify(availability);

        if (!isSameSeats)
          dispatch({ type: "SET_MAIN_SECTIONS", mainSections: availability });
      });
    }
    if (selectedSeatsNodes?.length >= groupNumOfTickets && !mapState.loading) {
      store.dispatch(setMaxSeatsReached(true));
    } else {
      store.dispatch(setMaxSeatsReached(false));
    }
    console.log({
      // 1: selectedSeatsNodes?.length < 20,
      // 2: mapState.loading,
      // 3: isIsolated,
      4: selectedMainSection,
      // 5: !mainSections,
    });
    const isDisable =
      selectedSeatsNodes?.length < 20 ||
      mapState.loading ||
      isIsolated ||
      !selectedMainSection ||
      !mainSections;
    toggleSubmit(isDisable);
    // toggleSubmit(true);
  }, [
    isIsolated,
    mapState.hoveredSeat,
    mapState.hoveredSection,
    mapState.seatDropdown,
    mapState.loading,
    mapState.noSeatsAvailable,
    mapState.seatsAvailableError,
    seatsInfo,
    selectedSeatsNodes,
    groupNumOfTickets,
    mainSections,
  ]);
  useEffect(() => {
    // console.log("loadMapHandler");
    if (
      !mapState.viewerInstance ||
      !mapState.viewer3dInstance ||
      !mapState.mainSections
    )
      return;
    loadMapHandler();
  }, [
    mapState.viewerInstance,
    mapState.viewer3dInstance,
    mapState.mainSections,
    mapState.routePath.length,
  ]);
  // useEffect(() => {
  //   store.dispatch(setMaxSeatsReached());
  // }, [selectedSeatsNodes]);
  // useEffect(() => {
  //   console.log("loaderShow", dragIsAnimating);
  // }, [dragIsAnimating]);
  return (
    <>
      <div className={classes.map}>
        <div className={classes.map__screen}>
          <div
            className={cx(classes.map__screen__container)}
            ref={mapContainerRef}
          />
          <div className={classes.map__screen__zoom}>
            <div
              className={classes.map__screen__navigation__btn}
              ref={zoomInRef}
            >
              <span>+</span>
            </div>
            <div
              className={classes.map__screen__navigation__btn}
              ref={zoomOutRef}
            >
              <span style={{ top: -11, left: 1 }}>_</span>
            </div>
          </div>
          <div className={classes.map__screen__navigation}>
            {mapState.routePath.length > 1 && (
              <>
                <div
                  className={classes.map__screen__navigation__btn}
                  onClick={goBackHandler}
                >
                  <ReactSVG
                    src={ArrowLeft}
                    beforeInjection={(svg) => {
                      svg.setAttribute(
                        "style",
                        `width: 19px;
              margin-top: 3px;`
                      );
                    }}
                  />
                </div>
                <div
                  className={classes.map__screen__navigation__btn}
                  onClick={goHomeHandler}
                >
                  <ReactSVG
                    src={StartOver}
                    beforeInjection={(svg) => {
                      svg.setAttribute(
                        "style",
                        `width: 22px;
                margin-top: 3px;`
                      );
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div className={classes.map__screen__message}>
            {isIsolated && (
              <div className={classes.map__screen__navigation__isolated}>
                <p>Selection cannot leave behind 1 stranded seat</p>
              </div>
            )}
            {maxSeatsReached && !isIsolated && (
              <div className={classes.map__screen__navigation__isolated}>
                <p>
                  You have reached the maximum of 49 seats. If you are looking
                  to book an outing for 50 or more guests, please click the
                  "Chat with a Nationals Representative" button at the bottom of
                  this screen
                </p>
              </div>
            )}
            {!mapState.seatsAvailableError && mapState.noSeatsAvailable && (
              <div className={classes.map__screen__navigation__isolated}>
                <p>There is no seat available</p>
              </div>
            )}
            {mapState.seatsAvailableError && (
              <div className={classes.map__screen__navigation__isolated}>
                <p>Technical issue, please try again later</p>
              </div>
            )}
          </div>
          <div
            className={cx(
              classes.map__screen__message,
              classes.map__screen__loader
            )}
          >
            {mapState.loading && (
              <div
                className={cx(
                  classes.map__screen__navigation__isolated,
                  classes.loaderMap
                )}
              >
                <div className={classes.spinner}>
                  <Spinner />
                </div>
                <p>Loading seats ...</p>
              </div>
            )}
          </div>
          {mapState.routePath.length > 2 && (
            <div className={classes.map__screen__multiselect}>
              {/* <img
                src={require("../../../../../../../assets/images/multiselect.png")}
                alt=""
              /> */}
              {/* <div
                className={classes.select_best_seats}
                onClick={SelectBestSeats}
              >
                Select best seats
              </div> */}

              <div className={cx(classes.swipe)}>
                <div
                  className={cx(
                    classes.path,
                    dragIsAnimating ? classes.animate_path : ""
                  )}
                ></div>
                <div
                  className={cx(
                    classes.hand_icon,
                    dragIsAnimating ? classes.animate_hand_icon : ""
                  )}
                ></div>
              </div>
              <p>
                For fastest seat selection, hold down CTRL key and drag over
                your desired group of seats
              </p>
            </div>
          )}
        </div>
        <div className={classes.sidebar}>
          <div className={classes.sidebar__header}>
            <div className={classes.num_of_tickets}>
              <h4 className={classes.planSubTitle}>
                {/* Group {pricingTier.tierName} */}
                Please Select
              </h4>
              <h2 className={classes.planTitle}>
                20 to 49 Tickets
                {/* {groupNumOfTicketsRef.current} Tickets */}
              </h2>
              {/* <div
                className={classes.change_ticket_btn}
                onClick={NumberOfTicketClickHandler}
              >
                Update
              </div> */}
            </div>

            {/* <div className={classes.planDescription}>
              Choose your preferred seating area below. The vouchers for your
              Pick 'Em Plan will be good for this location. As you redeem your
              vouchers on a fluid basis througout the season, you will claim
              your exact seats for each game.
            </div> */}
          </div>
          <div className={classes.sidebar__content}>
            {groupGameSelected && (
              <div className={classes.game}>
                <div className={classes.logos}>
                  <div className={classes.logo}>
                    <img
                      src={require("../../../../../../../assets/images/logo-natioanls.png")}
                      alt=""
                    />
                    <div className={classes.name}>Washington Nationals</div>
                  </div>
                  <span>vs.</span>
                  <div className={classes.logo}>
                    <img
                      src={`${CMS_ASSET_URL_BASE}${groupGameSelected.opponent.logo?.path}`}
                      alt="team logo"
                    />
                    <div className={classes.name}>
                      {groupGameSelected.opponent.name}
                    </div>
                  </div>
                </div>
                <div className={classes.date}>
                  <span>
                    {format(new Date(groupGameSelected.date), "EEEE")}
                  </span>
                  {", "}
                  <span>
                    {format(new Date(groupGameSelected.date), "MMMM")}
                  </span>{" "}
                  <span className={classes.date__day}>
                    {format(new Date(groupGameSelected.date), "d")}
                  </span>
                  {" - "}
                  <span className={classes.date__day}>
                    {format(new Date(groupGameSelected.date), "p")}
                  </span>
                </div>
              </div>
            )}
            <div className={classes.availability}>
              <div className={classes.availability__header}>
                <span>Seating Area</span>
                <span>Price</span>
              </div>
              <div className={classes.availability__list}>
                {loaderShow ? (
                  <div
                    className={cx(
                      parentClasses.loader__wrapper,
                      loaderShow ? parentClasses.loader__wrapper__active : ""
                    )}
                  >
                    <div className={parentClasses.loader}>
                      <Spinner />
                    </div>
                  </div>
                ) : (
                  <>
                    {seatsInfo !== "" && typeof seatsInfo !== "undefined" ? (
                      seatsInfo
                        .sort(
                          (a, b) =>
                            b.pricesFrom["41319"] - a.pricesFrom["41319"]
                        )
                        .map((seat, index) => {
                          if (!seat) return "";
                          return (
                            <div
                              key={index}
                              className={cx(
                                classes.availability__item,
                                classes.availability__item__section,
                                mapState.hoveredSection === seat.name
                                  ? classes["availability__item-active"]
                                  : ""
                              )}
                              onClick={() => {
                                listSectionClickHandler(seat);
                              }}
                              onMouseEnter={() => {
                                listSectionHoverHandler(seat.name);
                              }}
                              onMouseLeave={() => {
                                listSectionHoverHandler(null);
                              }}
                            >
                              <div className={classes.availability__item__name}>
                                {seat.name}
                              </div>
                              <div
                                className={classes.availability__item__price}
                              >
                                $
                                {seat.pricesFrom["41319"]?.toLocaleString(
                                  "en-US"
                                )}
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <div
                        className={cx(
                          parentClasses.loader__wrapper,
                          loaderShow
                            ? parentClasses.loader__wrapper__active
                            : ""
                        )}
                      >
                        <div className={parentClasses.loader}>
                          <Spinner />
                        </div>
                      </div>
                    )}{" "}
                  </>
                )}
              </div>
            </div>
            <div className={classes.sections__details} ref={refOpenSection}>
              <div className={classes.details__header}>
                <h3>
                  3D SEAT VIEW:<span> (click arrows to enlarge)</span>
                </h3>
              </div>
              <div
                className={classes.details__map_container}
                ref={viewer3dContainerRef}
              />
              <div className={classes.details__preview}>
                <div className={classes.details__preview__item}>
                  <span>section:</span>
                  {mapState.routePath.length > 1
                    ? getSectionNameById(
                        mapState.routePath[mapState.routePath.length - 1]
                      ).replace("S_", "")
                    : ""}
                </div>
                {/* <span className={classes.devider}>|</span>
                <div className={classes.details__preview__item}>
                  <span>Row2:</span>
                  {mapState.hoveredSeat.row}
                </div>
                <span className={classes.devider}>|</span>
                <div className={classes.details__preview__item}>
                  <span>Seat:</span>
                  {mapState.hoveredSeat.seat}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.details__seats}>
        <h2>
          <span>{selectedSeatsNodes?.length}</span> Seats Selected
          <span
            className={classes.reset_seats}
            onClick={() => removeAllSelectedSeats()}
          >
            Reset Seats
          </span>
        </h2>

        <h4>
          {selectedSeatsNodes?.length < 20 && (
            <span>
              Please select at least 20 tickets in order to qualify for
              discounted group pricing.
            </span>
          )}
        </h4>
        <div className={classes.details__seats__list}>
          {selectedSeatsNodes.map((seat, index) => (
            <div
              key={index}
              className={cx(
                classes.availability__item,
                classes.availability__seat_item
              )}
            >
              <div className={classes.availability__item__name}>
                <div>
                  <span>Section:</span> {seat.split("-")[0].replace("S_", "")}
                  {/* {mapState.routePath.length > 1
                    ? getSectionNameById(
                        mapState.routePath[mapState.routePath.length - 1]
                      ).replace("S_", "")
                    : ""} */}
                </div>
                <div>
                  <span>Row:</span> {seat.split("-")[1]}
                </div>
                <div>
                  <span>Seat:</span> {seat.split("-")[2]}
                </div>
              </div>
              <div
                className={classes.availability__item__price}
                onClick={() => {
                  deleteSelectedSeat(seat);
                }}
              >
                &times;
              </div>
            </div>
          ))}
        </div>
        {!selectedSeatsNodes || selectedSeatsNodes?.length === 0 ? (
          <p className={classes.no_seat_selected}>No seats selected</p>
        ) : (
          <p className={classes.checkout_text}>
            {/* Please tap the red arrow at the bottom of the page to check out. */}
          </p>
        )}
      </div>
    </>
  );
}

export default Map3D;
